export default __webpack_public_path__ + "static/media/account-icon.9cc91b56.svg";